/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import axios from 'axios';
import api from './api.services';
import {fetchApiDataFailure} from "../_actions/common.actions";
import {fetchAccessCodeSuccess} from "../_actions/access.code.actions";
import {showMessage} from "../_actions/message.actions";

export const saveAccessCode = (collectionId) => (dispatch, getState) => {
    axios.post(api.save_access_code_setup.replace('{collection-id}', collectionId), getState().accessCodeSetup)
        .then(response => {
            dispatch(fetchAccessCodeSuccess(response.data));
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const fetchAccessCodeInfo = (collectionId) => dispatch => {
    axios.get(api.get_access_code_setup.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchAccessCodeSuccess(response.data));
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });
};


// WEBPACK FOOTER //
// ./src/_thunks/access.code.thunk.js